import React from "react";
import dummy_image from "../../assets/img/default_avatar.jpg";
import "./chatItembox.css";
import { API_URL, CHAT_URL, JITSI_URL } from "../../../../config/app-config";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { BsCloudDownload, BsDownload, BsEye, BsFileText } from 'react-icons/bs';
import {
  sendMessage,
  ImageSendAction,
  InstantMeetingAction,
} from "../../store/actions/MessengerAction";
import { toast } from "react-toastify";
import moment from "moment";
import Picker from "emoji-picker-react";
import ScheduleForm from "./scheduleForm";
import AuthService from "../../../../session/AuthService_old";
import i18n from "../../../../i18n";
import i18next from "i18next";
import ProfileService from "../../../../api/ProfileService";
import ReactPlayer from "react-player";
import { generateUlr } from "../../../../utils";
import "moment/locale/en-gb"

function ChatItemBox({
  t,
  handleChatListBoxClose,
  currentFriend,
  user,
  socket,
  allFriends,
  messages,
  isMessageLoading,
}) {
  const dispatch = useDispatch();
  const divref = React.useRef(null);
  const textRef = React.useRef(null);
  const [isEmojiOpen, setIsEmojiOpen] = React.useState(false);
  const [isMeetingPanelOpen, setIsMeetingPanelOpen] = React.useState(false);
  const [isHovering, setIsHovering] = React.useState(false);
  const [isSchduleHovering, setIsSchduleHovering] = React.useState(false);
  const [showScheduledMeeting, setShowScheduledMeeting] = React.useState(false);
  const [selectedDate, handleDateChange] = React.useState(new Date());
  const [previewImage, setPreviewImage] = React.useState(null);

  moment.locale('en');

  const { messageSendSuccess } = useSelector(
    (state) => state.messenger,
    shallowEqual
  );

  const [newMessage, setNewMessage] = React.useState("");

  const handleClosePreview = () => {
    setPreviewImage(null);
  };

  // Image preview handler - now accepts full URL
  const handleImagePreview = (imageUrl) => {
    console.log('Preview image URL:', imageUrl);
    setPreviewImage(imageUrl);
  };

  const handleDownloadImage = (imageUrl) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = imageUrl.split('/').pop() || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFileName = (fileUrl) => {
    return fileUrl.split('/').pop() || 'document';
  };
  // Function to format timestamp like WhatsApp
  const formatMessageTime = (timestamp) => {
    const messageDate = moment(timestamp);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    if (messageDate.isSame(today, 'day')) {
      return messageDate.format('h:mm A');
    } else if (messageDate.isSame(yesterday, 'day')) {
      return `Yesterday, ${messageDate.format('h:mm A')}`;
    } else if (messageDate.isSame(today, 'week')) {
      return `${messageDate.format('dddd')}, ${messageDate.format('h:mm A')}`;
    } else {
      return messageDate.format('MMMM D, YYYY, h:mm A');
    }
  };

  // Function to check if we need to show date separator
  const shouldShowDateSeparator = (currentMessage, previousMessage) => {
    if (!previousMessage) return true;
    const currentDate = moment(currentMessage.created_at).startOf('day');
    const previousDate = moment(previousMessage.created_at).startOf('day');
    return !currentDate.isSame(previousDate);
  };

  // Function to format date separator
  const formatDateSeparator = (timestamp) => {
    const messageDate = moment(timestamp);
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');

    if (messageDate.isSame(today, 'd')) {
      return 'Today';
    } else if (messageDate.isSame(yesterday, 'd')) {
      return 'Yesterday';
    } else if (messageDate.isSame(today, 'year')) {
      return messageDate.format('MMMM D');
    } else {
      return messageDate.format('MMMM D, YYYY');
    }
  };

  const sendNotification = (message) => {
    const params = {
      receiverId: message.receiverId,
      senderId: message.senderId,
      notification: `${message.senderName} sent you a Message`,
      status: "new_chat_message",
      notificationType: 9,
    };

    ProfileService.sendCustomNotification(params).then((data) => {
      console.log("Notification Results :", data);
    });
  };

  const messagePayload = (message, isMeeting = false) => {
    return {
      senderName: user.dName,
      senderId: user.uId,
      receiverId: currentFriend?.userId,
      receiversList: allFriends,
      message: message,
      isMeeting: isMeeting,
    };
  };

  const handleShowMeeting = (e) => {
    setIsMeetingPanelOpen(!isMeetingPanelOpen);
  };

  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);
  const handleSchduleMouseEnter = () => setIsSchduleHovering(true);
  const handleSchduleMouseLeave = () => setIsSchduleHovering(false);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage(e);
    }
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (newMessage.trim().length === 0) {
      setNewMessage("");
      setIsEmojiOpen(false);
      return;
    }

    const data = messagePayload(newMessage.trim());
    setNewMessage("");
    setIsEmojiOpen(false);
    dispatch(sendMessage(data));
  };

  const handleEmoji = (e, { emoji }) => {
    const ref = textRef.current;
    ref.focus();
    const start = newMessage.substring(0, ref.selectionStart);
    const end = newMessage.substring(ref.selectionStart);
    const newText = start + emoji + end;
    setNewMessage(newText);
  };

  const linkify = (text) => {
    const urlRegex = /https?:\/\/[^\s]+/g;
    return text.split(urlRegex).reduce((acc, part, i) => {
      if (i === 0) return [part];
      const match = text.match(urlRegex)[i - 1];
      acc.push(
        <a
          href={match}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "blue", textDecoration: "underline" }}
          key={match + i}
        >
          {match}
        </a>,
        part
      );
      return acc;
    }, []);
  };

  const handleScheduledMeeting = (data) => {
    const message = { meeting: data };
    const formData = messagePayload(message, true);
    dispatch(InstantMeetingAction(formData));
  };

  const handleClose = () => {
    setShowScheduledMeeting(false);
  };

  const handleInstantMeeting = (e) => {
    e.preventDefault();
    setIsMeetingPanelOpen(false);
    const instantMeetingLink = `Betamonks${Math.floor(Math.random() * 100)}${user.uId}${currentFriend.userId}${Date.now()}`;

    const message = {
      meeting: {
        meetingLink: instantMeetingLink,
        meetingType: "Instant",
        meetingTime: new Date(),
      },
    };

    const data = messagePayload(message, true);
    dispatch(InstantMeetingAction(data));
  };

  const ImageSend = (e) => {
    const formdata = new FormData();
    const allowedfileType = [
      "text/csv",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/pdf",
      "application/docx",
      "text/plain",
      "image/jpeg",
      "image/png",
      "image/webp",
      "video/mp4",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    for (let i = 0; i < e.target.files.length; i++) {
      if (allowedfileType.includes(e.target.files[i].type)) {
        formdata.append("files", e.target.files[i]);
      } else {
        toast.warning("Selected File Types are Not Supported");
      }
    }

    formdata.append("senderName", user.dName);
    formdata.append("senderId", user.uId);
    formdata.append("receiverId", currentFriend?.userId);
    formdata.append("receiverName", currentFriend?.userName);

    if (e.target.files.length > 0) {
      dispatch(ImageSendAction(formdata));
    }
  };

  React.useEffect(() => {
    if (messageSendSuccess) {
      socket.current.emit("sendMessage", messages[messages.length - 1]);
      dispatch({
        type: "UPDATE_FRIEND_MESSAGE",
        payload: messages[messages.length - 1],
        isNotOwner: true,
      });
      dispatch({
        type: "CLEAR_MESSAGE_SEND_SUCCEESS",
        payload: false,
      });
    }
  }, [messageSendSuccess]);

  React.useEffect(() => {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }, []);

  React.useEffect(() => {
    divref.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const OpenEmojiContainer = () => {
    setIsEmojiOpen(!isEmojiOpen);
  };

  const handleShowModalScreen = () => {
    setIsMeetingPanelOpen(false);
    setShowScheduledMeeting(true);
  };

  const handleSetModalScreenClose = () => {
    setShowScheduledMeeting(false);
  };

  // Function to render media content properly
  const renderMediaContent = (message) => {
    if (!message.message.image || message.message.image.length === 0) {
      return null;
    }

    return (
      <div className="chatItemBox-message-media-list">
        {message.message.image.map((image, imgIndex) => {
          console.log(`image -> ${image}`);

          const imageTypeList = ["png", "jpg", "jpeg", "gif"];
          const document = ["pdf", "txt"];
          const imageTypeIndex = image.lastIndexOf(".");
          const imageType = image.substring(imageTypeIndex + 1).toLowerCase();
          const isImageType = imageTypeList.includes(imageType);
          const isDocument = document.includes(imageType);
          console.log("%c IS IMAGE TYPE :", "color:green", isImageType);
          console.log("%c IS Pdf TYPE :", "color:green", isDocument);

          // Use the image URL directly since it's already a full URL
          const mediaUrl = image;

          if (isImageType) {
            return (
              <div key={imgIndex}>
                <a
                  href={mediaUrl}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="chatItemBox-msg-img"
                    src={mediaUrl}
                    alt="Shared content"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = dummy_image;
                    }}
                  />
                </a>
              </div>
            );
          } else if (isDocument) {
            return (
              <div
                key={imgIndex}
                className="chatItemBox-file-box"
              >
                <a
                  href={mediaUrl}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "gray",
                    display: "flex",
                    flex: "3",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <BsCloudDownload size="5em" color="white" />
                </a>
                <a
                  href={mediaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="chatItemBox-file-link"
                >
                  Click to view document
                </a>
              </div>
            );
          } else {
            return (
              <div
                key={imgIndex}
                style={{
                  width: "auto",
                  height: "13rem",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <ReactPlayer
                  className="player"
                  controls
                  url={mediaUrl}
                />
              </div>
            );
          }
        })}
      </div>
    );
  };

  return (
    <div className="chatItemBox-container">
      {/* Image Preview Modal */}
      {previewImage && (
        <div className="image-preview-modal" onClick={handleClosePreview}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} alt="Preview" className="preview-image" />
            <button className="close-btn" onClick={handleClosePreview}>×</button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                const link = document.createElement('a');
                link.href = previewImage;
                link.download = 'image';
                link.click();
              }}
              className="download-full-btn"
            >
              <BsDownload size="1.2em" /> Download
            </button>
          </div>
        </div>
      )}

      <div className="chatItemBox--header">
        <div className="chatItemBox-img-container">
          <img
            src={`${API_URL}api/getUserPhoto/${currentFriend?.userId}/${currentFriend?.userName}`}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = dummy_image;
            }}
            alt="img"
            className="chatItemBox-avatar-img"
          />
          <span className="chatItemBox-header-username">
            {currentFriend?.userName}
          </span>
        </div>
        <div className="chatItemBox-icons-container">
          <div onClick={handleShowMeeting} className="chatItemBox-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              data-supported-dps="16x16"
              fill="currentColor"
              width="16"
              height="16"
              focusable="false"
            >
              <path d="M1 5v6a2 2 0 002 2h8V3H3a2 2 0 00-2 2zm4 0h2v2h2v2H7v2H5V9H3V7h2zm10-1v8h-1.5l-1.5-.75v-6.5L13.5 4z"></path>
            </svg>
          </div>
          <div onClick={() => handleChatListBoxClose()} className="chatItemBox-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              data-supported-dps="16x16"
              fill="currentColor"
              width="16"
              height="16"
              focusable="false"
            >
              <path d="M14 3.41L9.41 8 14 12.59 12.59 14 8 9.41 3.41 14 2 12.59 6.59 8 2 3.41 3.41 2 8 6.59 12.59 2z"></path>
            </svg>
          </div>
        </div>

        {isMeetingPanelOpen && (
          <div className="chatItemBox-meeting-dropdown">
            <p
              onClick={handleInstantMeeting}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ background: isHovering ? "#f5f5f5" : "white" }}
            >
              {i18next.t("Instant Meeting")}
            </p>
            <p
              onClick={handleShowModalScreen}
              onMouseEnter={handleSchduleMouseEnter}
              onMouseLeave={handleSchduleMouseLeave}
              style={{ background: isSchduleHovering ? "#f5f5f5" : "white" }}
            >
              {i18next.t("Schedule Meeting")}
            </p>
          </div>
        )}
      </div>

      <div className="chatItemBox--body">
        <div className="chatItemBox-message-list">
          {isMessageLoading ? (
            <div className="chatItemBox-loading">Loading...</div>
          ) : (
            messages &&
            messages.length > 0 &&
            messages.map((message, index) => {
              const previousMessage = index > 0 ? messages[index - 1] : null;
              const showDateSeparator = shouldShowDateSeparator(message, previousMessage);

              return (
                <React.Fragment key={index}>
                  {/* Date Separator */}
                  {showDateSeparator && (
                    <div className="chatItemBox-date-separator">
                      {formatDateSeparator(message.created_at)}
                    </div>
                  )}

                  {/* Message Item */}
                  <div
                    className={`chatItemBox-message-item ${+message.senderId === +user.uId
                      ? "chatItemBox-message-sent"
                      : "chatItemBox-message-received"
                      }`}
                    ref={divref}
                  >
                    <img
                      src={`${API_URL}api/getUserPhoto/${message.senderId}/${message.senderName}`}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = dummy_image;
                      }}
                      alt="avatar"
                      className="chatItemBox-message-avatar"
                    />
                    <div className="chatItemBox-message-content">
                      {/* Media Content */}
                      {message.message.text.length === 0 && !message.isMeeting && renderMediaContent(message)}

                      {/* Text Content */}
                      {message.message.text.length > 0 && !message.isMeeting && (
                        <div className="chatItemBox-message-text">
                          {linkify(message.message.text)}
                        </div>
                      )}

                      {/* Meeting Content */}
                      {message.isMeeting && (
                        <div
                          className="chatItemBox-meeting-box"
                          onClick={() =>
                            generateUlr(
                              `${JITSI_URL}${message?.message?.meeting?.meetingLink}?authenticated=true&sp=yes`
                            )
                          }
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 16 16"
                              data-supported-dps="16x16"
                              fill="currentColor"
                              width="20"
                              height="20"
                              focusable="false"
                            >
                              <path d="M1 5v6a2 2 0 002 2h8V3H3a2 2 0 00-2 2zm4 0h2v2h2v2H7v2H5V9H3V7h2zm10-1v8h-1.5l-1.5-.75v-6.5L13.5 4z"></path>
                            </svg>
                            <div>
                              {message?.message?.meeting?.meetingType === "Scheduled" ? (
                                <>
                                  <div className="chatItemBox-meeting-title">
                                    {message?.message?.meeting?.meetingName || "Join Meeting"}
                                  </div>
                                  <div className="chatItemBox-meeting-time">
                                    {moment(message?.message?.meeting?.meetingTime)
                                      .format('MMM DD, YYYY, h:mm A')}
                                  </div>
                                  <div className="chatItemBox-meeting-status">
                                    {message?.message?.meeting?.isMeetingfinished
                                      ? "Meeting Ended"
                                      : "Join Video Meeting"}
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="chatItemBox-meeting-title">
                                    {+message.senderId === +user.uId
                                      ? `${user.dName}'s Meeting`
                                      : `${currentFriend?.userName}'s Meeting`}
                                  </div>
                                  <div className="chatItemBox-meeting-status">
                                    {message?.message?.meeting?.isMeetingfinished
                                      ? "Meeting Ended"
                                      : "Join Video Meeting"}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Message Footer */}
                      <div className="chatItemBox-message-footer">
                        <span className="chatItemBox-message-time">
                          {formatMessageTime(message.created_at)}
                        </span>
                        {user.uId === +message?.senderId && (
                          <div className="message-status-container">
                            <div className={`message-status ${message?.status}`}>
                              {message?.status === "seen" ? (
                                <div className="seen-status">
                                  <svg className="checkmark seen" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L7 9.586 5.707 8.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z" />
                                  </svg>
                                  <svg className="checkmark seen" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L7 9.586 5.707 8.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z" />
                                  </svg>
                                </div>
                              ) : message?.status === "delivered" ? (
                                <div className="delivered-status">
                                  <svg className="checkmark delivered" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L7 9.586 5.707 8.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z" />
                                  </svg>
                                  <svg className="checkmark delivered" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L7 9.586 5.707 8.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z" />
                                  </svg>
                                </div>
                              ) : (
                                <div className="sent-status">
                                  <svg className="checkmark sent" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L7 9.586 5.707 8.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z" />
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })
          )}
        </div>
      </div>

      <div className="chatItemBox--footer">
        {showScheduledMeeting && (
          <ScheduleForm
            handleSchduledMeeting={handleScheduledMeeting}
            loginedUserDetails={user}
            users={currentFriend}
            showModalScreen={handleScheduledMeeting}
            handleClose={handleClose}
            handleModalScreenVisibility={handleSetModalScreenClose}
          />
        )}

        <div className="chatItemBox--footer-text-box">
          <textarea
            ref={textRef}
            placeholder="Write a Message"
            value={newMessage}
            onKeyPress={handleKeyPress}
            onChange={(e) => setNewMessage(e.target.value)}
            className="chatItemBox-textarea"
            rows="1"
          ></textarea>
        </div>

        <div className="chatItemBox--footer-send-box">
          <div className="chatItemBox--footer-emoji-container">
            <div>
              <label htmlFor="file-input" className="chatItemBox-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  data-supported-dps="16x16"
                  fill="currentColor"
                  width="16"
                  height="16"
                  focusable="false"
                >
                  <path d="M14 3H2a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1zM3 11l3-2.95L9 11H3zm10 0h-2.77L6.31 7.13a.44.44 0 00-.62 0L3 9.77V5h10v6zm-2.5-2A1.5 1.5 0 109 7.5 1.5 1.5 0 0010.5 9zm0-2.25a.75.75 0 11-.75.75.75.75 0 01.75-.75z"></path>
                </svg>
              </label>
              <input
                onChange={ImageSend}
                type="file"
                name="file"
                id="file-input"
                multiple
                style={{ display: "none" }}
              />
            </div>

            <div onClick={OpenEmojiContainer} className="chatItemBox-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                data-supported-dps="16x16"
                fill="currentColor"
                width="16"
                height="16"
                focusable="false"
              >
                <path d="M4.84 6A1.16 1.16 0 116 7.17 1.17 1.17 0 014.84 6zM8 9.38a3.51 3.51 0 01-2.3-.81l-.83 1.29a4.87 4.87 0 006.25 0l-.82-1.28a3.51 3.51 0 01-2.3.8zm2-4.55A1.17 1.17 0 1011.16 6 1.17 1.17 0 0010 4.83zM8 2.88A5.12 5.12 0 112.88 8 5.12 5.12 0 018 2.88M8 1a7 7 0 107 7 7 7 0 00-7-7z"></path>
              </svg>
            </div>
          </div>

          <button
            disabled={newMessage.trim().length === 0}
            onClick={handleSendMessage}
            className="chatItemBox-send-btn"
          >
            Send
          </button>
        </div>
      </div>

      {isEmojiOpen && (
        <div className="chatItemBox-emoji-picker">
          <Picker
            onEmojiClick={handleEmoji}
            disableAutoFocus={true}
            groupNames={{ smileys_people: "PEOPLE" }}
            native
          />
        </div>
      )}
    </div>
  );
}

export default ChatItemBox;